import dayjs from 'dayjs';

// TODO: currently duplicated in web and mobile, new package needed to stop this
export const validateTableNumber = (text = '') => {
  if (text === '') {
    return true;
  }
  const isValid = /^[1-9][0-9]?$/.test(text.trim());

  return isValid;
};

export const validatePickupTime = time => {
  if (time === '' || time === 'ASAP') {
    return true;
  }

  const difference = dayjs(time).diff(dayjs(), 'minutes');

  if (difference >= 14) {
    return true;
  }

  return false;
};
